// extracted by mini-css-extract-plugin
export default {"container":"YGDD0a","listItem":"F97AmI","desktopListItem":"qeUYnG","withFooter":"SAhs70","mobileListItem":"Dc82ak"};